import ProductRequest from '@/shared/infrastructure/products/Request'

const actions = {
  getProductInfo(action, id) {
    return ProductRequest.getProductInfo(id)
  },
  getProductPreviewInfo(action, id) {
    return ProductRequest.getProductPreviewInfo(id)
  },
  fetchQuickSearchResults(action, payload) {
    return ProductRequest.quickSearch(payload)
  },
  fetchSearchResults(action, payload) {
    return ProductRequest.fetchSearchResults(payload)
  },
  fetchFiltersForSearchResults(action, payload) {
    return ProductRequest.fetchFilters(payload);
  },
  fetchFeaturedProducts() {
    return ProductRequest.fetchFeaturedProducts()
  },
  fetchHotProducts() {
    return ProductRequest.fetchHotProducts()
  },
  fetchTrendingProducts() {
    return ProductRequest.fetchTrendingProducts()
  },
  fetchNewProducts() {
    return ProductRequest.fetchNewProducts()
  }
}

export default actions
